import { useState, useEffect } from "react";
import { useAuth } from "../../../context/AuthProvider";
import {
  BuildingOffice2Icon,
  UserGroupIcon,
  DocumentCheckIcon,
  WalletIcon,
  IdentificationIcon,
  XMarkIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import axios from "axios";

export default function SocieteAudit({ societe, open, onClose, onSave }) {
  const { user } = useAuth();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    type: "Personne Morale",
    statut: "Lead",
    referent: user?.Nom || "Non assigné",

    denomination: "",
    siret: "",
    statutJuridique: "",
    secteurActivite: "",
    dateCreation: "",
    capitalSocial: 0,

    dirigeants: [],

    adresse: "",
    codePostal: "",
    ville: "",
    pays: "",
    email: "",
    telephone: "",
    siteWeb: "",

    chiffreAffaires: 0,
    resultatNet: 0,
    effectif: 0,
    besoinFinancement: 0,
    projetFinancement: "",

    documents: [],
    commentaires: "",
    dateAjout: new Date().toISOString().split("T")[0],
    auditeur: user?.Nom || "",
    signature: false,
  });

  useEffect(() => {
    if (societe) {
      setFormData((prev) => ({
        ...prev,
        ...societe,
        dateAjout: new Date().toISOString().split("T")[0],
        auditeur: user?.Nom || "",
      }));
    }
  }, [societe, user]);

  const steps = [
    { label: "Identification", icon: <IdentificationIcon className="w-5 h-5" /> },
    { label: "Coordonnées", icon: <BuildingOffice2Icon className="w-5 h-5" /> },
    { label: "Dirigeants", icon: <UserGroupIcon className="w-5 h-5" /> },
    { label: "Finances", icon: <WalletIcon className="w-5 h-5" /> },
    { label: "Validation", icon: <CheckCircleIcon className="w-5 h-5" /> },
  ];

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === "number" ? Number(value) : value }));
  };

  const BACKEND_URL =
    window.location.hostname === "localhost"
      ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
      : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

  const handleSubmit = async () => {
    try {
      const response = await axios.put(`${BACKEND_URL}/societes/${societe._id}`, formData);
      alert("Audit société enregistré avec succès !");
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error);
      alert("Erreur lors de l'enregistrement.");
    }
  };

  const updateDirigeantField = (index, e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updated = [...prev.dirigeants];
      updated[index] = { ...updated[index], [name]: value };
      return { ...prev, dirigeants: updated };
    });
  };  

  const blocFields = {
    1: (
        <>
          <label className="block text-sm font-medium">Dénomination</label>
          <input
            name="denomination"
            value={formData.denomination}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
      
          <label className="block text-sm font-medium">Statut juridique</label>
          <input
            name="statutJuridique"
            value={formData.statutJuridique}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
      
          <label className="block text-sm font-medium">Secteur d'activité</label>
          <input
            name="secteurActivite"
            value={formData.secteurActivite}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
      
          <label className="block text-sm font-medium">Date de création</label>
          <input
            type="date"
            name="dateCreation"
            value={formData.dateCreation}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
      
          <label className="block text-sm font-medium">Capital social (€)</label>
          <input
            type="number"
            name="capitalSocial"
            value={formData.capitalSocial}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
      
          <label className="block text-sm font-medium">SIRET</label>
          <input
            name="siret"
            value={formData.siret}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2 mb-2"
          />
        </>
      ),      
      2: (
        <>
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="text-sm font-medium">Adresse</label>
              <input name="adresse" value={formData.adresse} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="text-sm font-medium">Code postal</label>
              <input name="codePostal" value={formData.codePostal} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="text-sm font-medium">Ville</label>
              <input name="ville" value={formData.ville} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="text-sm font-medium">Pays</label>
              <input name="pays" value={formData.pays} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="text-sm font-medium">Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="text-sm font-medium">Téléphone</label>
              <input name="telephone" value={formData.telephone} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <label className="text-sm font-medium">Site web</label>
          <input name="siteWeb" value={formData.siteWeb} onChange={handleChange} className="w-full border rounded px-3 py-2" />
        </>
      ),      
      3: (
        <>
          {formData.dirigeants.map((dir, index) => (
            <div key={index} className="border rounded p-4 mb-4 relative bg-gray-50">
              <div className="absolute top-2 right-2 text-red-500 cursor-pointer" onClick={() => {
                const updated = [...formData.dirigeants];
                updated.splice(index, 1);
                setFormData((prev) => ({ ...prev, dirigeants: updated }));
              }}>✕</div>
      
              {/* Identité */}
              <div className="flex gap-2">
                <div className="w-1/2">
                  <label className="text-sm font-medium">Civilité</label>
                  <select name="civilite" value={dir.civilite || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-full border rounded px-3 py-2 mb-2">
                    <option value="">--</option>
                    <option value="Monsieur">Monsieur</option>
                    <option value="Madame">Madame</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>
                <div className="w-1/2">
                  <label className="text-sm font-medium">Genre</label>
                  <select name="genre" value={dir.genre || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-full border rounded px-3 py-2 mb-2">
                    <option value="">--</option>
                    <option value="Homme">Homme</option>
                    <option value="Femme">Femme</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>
              </div>
      
              <div className="flex gap-2">
                <input name="nom" placeholder="Nom" value={dir.nom} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="prenom" placeholder="Prénom" value={dir.prenom} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input type="date" name="dateNaissance" value={dir.dateNaissance || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="lieuNaissance" placeholder="Lieu naissance" value={dir.lieuNaissance || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input name="nationalite" placeholder="Nationalité" value={dir.nationalite || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="email" placeholder="Email" value={dir.email || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input name="telephone" placeholder="Téléphone" value={dir.telephone || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="adresse" placeholder="Adresse" value={dir.adresse || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input name="codePostal" placeholder="Code postal" value={dir.codePostal || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="ville" placeholder="Ville" value={dir.ville || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input name="pays" placeholder="Pays" value={dir.pays || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="fonction" placeholder="Fonction" value={dir.fonction || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <select name="typeMandat" value={dir.typeMandat || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2">
                  <option value="">Type de mandat</option>
                  <option value="Statutaire">Statutaire</option>
                  <option value="Délégation">Délégation</option>
                  <option value="Conseil d’administration">Conseil d’administration</option>
                  <option value="Supervisory">Supervisory</option>
                </select>
                <input type="date" name="datePriseFonction" value={dir.datePriseFonction || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input type="date" name="dateFinMandat" value={dir.dateFinMandat || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input type="number" step="0.01" name="pourcentageCapital" placeholder="% Capital" value={dir.pourcentageCapital || 0} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <input type="number" step="0.01" name="pourcentageDroitsVote" placeholder="% Droits de vote" value={dir.pourcentageDroitsVote || 0} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <select name="beneficiaireEffectif" value={dir.beneficiaireEffectif ? "true" : "false"} onChange={(e) => updateDirigeantField(index, { target: { name: "beneficiaireEffectif", value: e.target.value === "true" } })} className="w-1/2 border rounded px-3 py-2 mb-2">
                  <option value="false">Non bénéficiaire</option>
                  <option value="true">Bénéficiaire effectif</option>
                </select>
              </div>
      
              <div className="flex gap-2">
                <input name="documentIdentite" placeholder="URL pièce identité" value={dir.documentIdentite || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
                <input name="justificatifDomicile" placeholder="URL justificatif domicile" value={dir.justificatifDomicile || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2" />
              </div>
      
              <div className="flex gap-2">
                <select name="pep" value={dir.pep ? "true" : "false"} onChange={(e) => updateDirigeantField(index, { target: { name: "pep", value: e.target.value === "true" } })} className="w-1/2 border rounded px-3 py-2 mb-2">
                  <option value="false">Non PEP</option>
                  <option value="true">PEP</option>
                </select>
                <select name="kycStatus" value={dir.kycStatus || ""} onChange={(e) => updateDirigeantField(index, e)} className="w-1/2 border rounded px-3 py-2 mb-2">
                  <option value="">KYC</option>
                  <option value="Non Collecté">Non Collecté</option>
                  <option value="En Attente">En Attente</option>
                  <option value="Validé">Validé</option>
                  <option value="Refusé">Refusé</option>
                </select>
              </div>
      
              <textarea name="remarque" placeholder="Remarque" value={dir.remarque || ""} onChange={(e) => updateDirigeantField(index, e)} rows={2} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          ))}
      
          <button type="button" onClick={() =>
            setFormData((prev) => ({
              ...prev,
              dirigeants: [
                ...prev.dirigeants,
                {
                  nom: "",
                  prenom: "",
                  civilite: "",
                  genre: "",
                  dateNaissance: "",
                  lieuNaissance: "",
                  nationalite: "",
                  email: "",
                  telephone: "",
                  adresse: "",
                  codePostal: "",
                  ville: "",
                  pays: "",
                  fonction: "",
                  typeMandat: "",
                  datePriseFonction: "",
                  dateFinMandat: "",
                  pourcentageCapital: 0,
                  pourcentageDroitsVote: 0,
                  beneficiaireEffectif: false,
                  documentIdentite: "",
                  justificatifDomicile: "",
                  pep: false,
                  kycStatus: "",
                  remarque: ""
                }
              ]
            }))
          } className="text-sm text-blue-600 hover:underline mt-2">+ Ajouter un dirigeant</button>
        </>
      ),      
      4: (
        <>
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="block text-sm font-medium">Chiffre d'affaires (€)</label>
              <input type="number" name="chiffreAffaires" value={formData.chiffreAffaires} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium">Résultat net (€)</label>
              <input type="number" name="resultatNet" value={formData.resultatNet} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="block text-sm font-medium">Effectif</label>
              <input type="number" name="effectif" value={formData.effectif} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium">Besoin de financement (€)</label>
              <input type="number" name="besoinFinancement" value={formData.besoinFinancement} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <div>
            <label className="block text-sm font-medium">Projet de financement</label>
            <textarea name="projetFinancement" value={formData.projetFinancement} onChange={handleChange} rows={2} className="w-full border rounded px-3 py-2 mb-2" />
          </div>
        </>
      ),      
      5: (
        <>
          <div>
            <label className="block text-sm font-medium">Commentaires</label>
            <textarea name="commentaires" value={formData.commentaires} onChange={handleChange} rows={2} className="w-full border rounded px-3 py-2 mb-2" />
          </div>
      
          <div className="flex gap-2">
            <div className="w-1/2">
              <label className="block text-sm font-medium">Date d'audit</label>
              <input type="date" name="dateAjout" value={formData.dateAjout?.slice(0, 10)} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium">Auditeur</label>
              <input name="auditeur" value={formData.auditeur} onChange={handleChange} className="w-full border rounded px-3 py-2 mb-2" />
            </div>
          </div>
      
          <div className="flex items-center gap-2 mt-2">
            <input type="checkbox" name="signature" checked={formData.signature} onChange={(e) => setFormData((prev) => ({ ...prev, signature: e.target.checked }))} className="h-4 w-4 text-blue-600" />
            <label className="text-sm text-gray-700">Audit signé</label>
          </div>
        </>
      ),
      6: (
        <>
          {formData.documents.length > 0 && formData.documents.map((doc, index) => (
            <div key={index} className="border rounded-md p-3 bg-gray-50 relative mb-3">
              <label className="block text-sm font-medium">Nom du document</label>
              <input
                name="nom"
                value={doc.nom}
                onChange={(e) => {
                  const updated = [...formData.documents];
                  updated[index].nom = e.target.value;
                  setFormData((prev) => ({ ...prev, documents: updated }));
                }}
                className="w-full border rounded px-3 py-2 mb-2"
              />
      
              <label className="block text-sm font-medium">URL du document</label>
              <input
                name="url"
                value={doc.url}
                onChange={(e) => {
                  const updated = [...formData.documents];
                  updated[index].url = e.target.value;
                  setFormData((prev) => ({ ...prev, documents: updated }));
                }}
                className="w-full border rounded px-3 py-2"
              />
      
              <button
                type="button"
                onClick={() => {
                  const filtered = formData.documents.filter((_, i) => i !== index);
                  setFormData((prev) => ({ ...prev, documents: filtered }));
                }}
                className="absolute top-1 right-2 text-red-500 text-sm"
              >
                ✕
              </button>
            </div>
          ))}
      
          <button
            type="button"
            onClick={() =>
              setFormData((prev) => ({
                ...prev,
                documents: [...prev.documents, { nom: "", url: "" }],
              }))
            }
            className="text-sm text-blue-600 hover:underline"
          >
            + Ajouter un document
          </button>
        </>
      ),      
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/50" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="relative bg-white rounded-lg shadow-lg w-full max-w-3xl p-6">
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
            <XMarkIcon className="w-6 h-6" />
          </button>
          <DialogTitle className="text-xl font-bold text-gray-800 mb-4 text-center flex items-center gap-2">
            {steps[step - 1].icon} Étape {step} : {steps[step - 1].label}
          </DialogTitle>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6">
            <div className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style={{ width: `${(step / steps.length) * 100}%` }} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[65vh] overflow-y-auto pr-2">
            {blocFields[step]}
          </div>
          <div className="flex justify-between mt-6">
            <button disabled={step === 1} onClick={() => setStep((s) => s - 1)} className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg">
              Précédent
            </button>
            {step < steps.length ? (
              <button onClick={() => setStep((s) => s + 1)} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg">
                Suivant
              </button>
            ) : (
              <button onClick={handleSubmit} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg">
                Enregistrer l’audit
              </button>
            )}
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
